import EntitiesPage from "./EntitiesPage";

// Clients = who pays you for services rendered: income receipts. Money in.
export default function Clients() {
  return (
    <EntitiesPage
      kind="client"
      title="Clients"
      subtitle="Who pays you, rolled up across every income receipt."
      entityLabel="Client"
      amountLabel="Total received"
      basePath="/app/clients"
    />
  );
}
